const LINK_TYPE_FILE_LINK: string = 'file-link';

export default LINK_TYPE_FILE_LINK;
